import React, { useState, useEffect } from 'react';
import { useNavigate, useRouteLoaderData, defer } from "react-router-dom";
import ButtonPolicy from "src/components/Permission/ButtonPolicy";
import { Grid, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { useAlertContext } from 'src/hooks/use-alert';
import 'src/components/NoteBook/notebook.css';
import BudgetDataGridComponent from 'src/components/DataGrid/BudgetDataGrid';
import { CSVLink } from 'react-csv';
import Image from 'mui-image';
import csv from 'src/img/csv.png';
import pdf from 'src/img/pdf.png';
import "./Deals.css";
import DealForm from './DealForm';
import { getAllDeals,getDeal,UpdateDeal } from 'src/apis/deals';
import DialogWrapper from 'src/components/Dialogs/Dialog';
import { DeleteDeal } from 'src/apis/deals';
const Deals = () => {
  const allDeals = useRouteLoaderData("deals"); // retrieve loaded deals 
  const alert = useAlertContext();
  const [openDealForm, setOpenDealForm]=useState(false);  
  const [deals, setDeals] = useState([]);
  const [csvData,setCsvData]=useState([])     /**   Csv file data container **/
  const [refresh,setRefresh]=useState(false);  /**  reload page  on submit **/
  const [showDialog,setShowDialog]=useState(false);
  const [selectedDeal,setSelectedDeal]=useState(null);
  const [editSelectedDeal,setEditSelectedDeal]=useState(null);
  const [editFormControl,setEditFormControl]=useState(false)
  const columns = [
    { field: 'Name', headerName: 'Name', flex: 1 },
    { field: 'Service', headerName: 'Service', flex: 1 },
    { field: 'Price', headerName: 'Price', flex: 1 },
    { field: 'Finance', headerName: 'Finance', flex: 1 },
    { field: 'Start', headerName: 'Start', flex: 1 },
    { field: 'Other', headerName: 'Other', flex: 1 },];

  

useEffect(() => {

  if (allDeals.deals && allDeals.deals.length > 0) {
   // let id = 0;
    const deals_ = allDeals.deals.map((deal) => {
        return { id: deal.id, Name: deal.name, Service: deal.service, Price: deal.price, Finance:deal.finance, Start:deal.start,Other:deal.other };
    });
    setDeals(deals_);
  }
}, [allDeals.deals]);

useEffect(() => {

  if (refresh) {
    const fetchData = async () => {
      try {
          var deals_ = await getAllDeals();
         
          deals_ = deals_.map((deal) => {
              return { id: deal.id, Name: deal.name, Service: deal.service, Price: deal.price, Finance:deal.finance, Start:deal.start, Other:deal.other };
          });
          setDeals(deals_);
          setRefresh(false)
      } catch (error) {
          // Handle error if needed
          console.error(error);
      }
  };

  fetchData();
  }
}, [refresh]);



  const handleNewDeal = () => {
    setOpenDealForm(true)
  };
  const handleClickClose = () => {
    setOpenDealForm(false)
    if(editFormControl){
      setEditFormControl(false)
    }
    
  }
  /**  use handler function instead of passing setState  **/
  const handlerFunction = () => { 
    setRefresh(true)
}


  /**UseEffect for prepping CsvData */
  useEffect(()=>{
    if(deals){
      const data = deals.map((row) => ({
        Name: row.Name,
        Service: row.Service,
        Price: row.Price,
        Finance: row.Finance,
        Start: row.Start,
        Other: row.Other,
    }));
    
     setCsvData(data);
  
    }
  
  },[deals])
  const clickRow = (data) => {
    setShowDialog(true);
    if(data){
    setSelectedDeal({id: data.id, name:data.Name,description:data.Finance,price:data.Price,date:data.Start
    })} //to be fed to show on dialog with edit button
    setEditSelectedDeal(data)
    console.log("logic ok")
  };  
  
  useEffect(()=>{
    console.log(selectedDeal)
  
  },[selectedDeal])

const closeDialog =() =>{
  setShowDialog(false);
}

  return (
    <div className='notebookContainer'>
      <h1 className='DealsHeader'>Deals Management</h1>
      <Grid container>
      <div className='addNewDeal'>
              <ButtonPolicy onClick={handleNewDeal}>Add New Deal</ButtonPolicy>
            </div>
        <div className='datagrid-container'>
      <DealForm visbile={openDealForm || editFormControl}  onClose={handleClickClose} refreshControl={handlerFunction} editSelectedDeal={editSelectedDeal}  editMode={editFormControl}/>
        {/* Table */}

        {deals.length > 0 ? (
          <div className='DealsDatagrid'>
        <BudgetDataGridComponent rows={deals} columns={columns} apicall={clickRow}  />
        <DialogWrapper visbile={showDialog} onClose={closeDialog} data={selectedDeal} deletecall={DeleteDeal} openEditForm={setEditFormControl} refreshControl={handlerFunction}/>
        {/* Bottom right div */}
        <div className='bottom-container'>
        <Grid item md={3} lg={3} sm={6} xs={12}>
          <div className='cardHolder'>
            
          </div>
        </Grid>
          {/*csv image button */}
          <CSVLink className='csvImageHolder' data={csvData} headers={columns.map((column) => ({
            label: column.headerName,
            key: column.field,
          }))}>
            
              <Image src={csv} />
            
          </CSVLink>
          {/*pdf image button */}
          <div className='csvImageHolder'>
            <Image src={pdf} />
          </div>
        </div>
        </div>): (
                 <div className='condtionalInfo'> <h2>There aren't any deals yet, Please add some !</h2></div>
            )}
      </div>
      </Grid>
    </div>
  );
};

export default Deals;
async function loadDeals() {
  const response = await getAllDeals();
  return response;
}
export async function loader() {
  return defer({
    deals: await loadDeals(),
  });
}
